module.exports = __webpack_public_path__ + "img/j2.c24feb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/j2.jpg
// module id = EZMe
// module chunks = 1